import { render, staticRenderFns } from "./TotalMatchComponent.vue?vue&type=template&id=ab70b8d2"
import script from "./TotalMatchComponent.vue?vue&type=script&lang=js"
export * from "./TotalMatchComponent.vue?vue&type=script&lang=js"
import style0 from "./TotalMatchComponent.vue?vue&type=style&index=0&id=ab70b8d2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab70b8d2')) {
      api.createRecord('ab70b8d2', component.options)
    } else {
      api.reload('ab70b8d2', component.options)
    }
    module.hot.accept("./TotalMatchComponent.vue?vue&type=template&id=ab70b8d2", function () {
      api.rerender('ab70b8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/audiences/components/TotalMatchComponent.vue"
export default component.exports